export const TRUE_FALSE = {true: 'Да', false: 'Нет'};
